import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface IHouseholdSize {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllHouseholds?: number | null;
  onePerson?: number | null;
  twoPeople?: number | null;
  threePeople?: number | null;
  fourPeople?: number | null;
  fivePeople?: number | null;
  sixPeople?: number | null;
  sevenPeople?: number | null;
  eightOrMorePeople?: number | null;
}

export const defaultValue: Readonly<IHouseholdSize> = {};
